import React, { useState } from "react"
import { Params, useParams } from "react-router-dom";
import TabsComp from "components/TabsComp";
import TableComp from "components/Table";
import { faFileExcel, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import PaginationComp from "components/Pagination";
import CustomTitle from "components/CustomTitle";
import ButtonIcon from "components/ButtonComp";
import useLoading from "hooks/useLoading";
import * as XLSX from 'xlsx';
import ETDChart from "./Charts";
import useETDStatuses from "hooks/useETDStatuses";
import { IETDStatus } from "models/ETDStatus";

const IndexETD: React.FC = () => {
    const { encryptedId } = useParams<Params>();
    const hookETDStatus = useETDStatuses({ etd_id: Number(encryptedId) });
    const hookETDStatusExport = useETDStatuses({ etd_id: Number(encryptedId), pageSize: 1000000 });
    const hookLoading = useLoading({ defaultLoading: false });
    const [activeKey, setActiveKey] = useState("1");

    const handleDownloadXLSX = () => {
        hookLoading.start();
        try {
            const exportData = hookETDStatusExport.data.map((item: IETDStatus) => ({
                'ID': item.id,
                'Dispositivo': item.etd_id,
                'Fecha': item.created_at,
                'No. Detector': item.No_detector,
                'Estado': item.Estado,
                'Congestión': item.Congestion ? "Sí" : "No",
                'Sentido Contrario': item.Sent_contrario ? "Sí" : "No",
                'Sentido Circulación': item.Sent_circulacion ? "Sí" : "No",
                'Longitud': item.Longitud,
                'Distancia': item.Distancia,
                'Intensidad': item.Intensidad,
                'Ocupación': item.Ocupacion,
                'Velocidad': item.Velocidad,
                'Error Relativo': item.Error_relativo,
                'Longitud 1': item.longitud_1,
                'Longitud 2': item.longitud_2,
                'Longitud 3': item.longitud_3,
                'Longitud 4': item.longitud_4,
                'Velocidad 1': item.velocidad_1,
                'Velocidad 2': item.velocidad_2,
                'Velocidad 3': item.velocidad_3,
                'Estado Conexión': item.is_online ? "Online" : "Offline"
            }));


            // Create worksheet
            const ws = XLSX.utils.json_to_sheet(exportData);

            // Create workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Datos ETD');

            // Generate filename with timestamp
            const fileName = `ETD_${new Date().getTime()}.xlsx`;

            // Save the file
            XLSX.writeFile(wb, fileName);
        } catch (error) {
            console.error('Error al exportar a XLSX:', error);
        } finally {
            hookLoading.end();
        }
    }

    return (
        <div style={{ width: "100%", margin: "auto", padding: "20px", borderRadius: "8px" }}>
            <CustomTitle title="ETD" />
            <TabsComp
                defaultActiveKey={activeKey}
                activeKey={activeKey}
                onChange={(key) => setActiveKey(key)}
                items={[{
                    key: '1',
                    label: 'Datos',
                    children: <div>
                        <CustomTitle
                            className="mb-2"
                            actions={
                                <ButtonIcon name="Descargar" icon={faFileExcel} variant="success" onClick={handleDownloadXLSX} disabled={hookLoading.isLoading} />
                            }
                        />
                        <TableComp
                            headers={[
                                "#",
                                "ETD ID",
                                "Fecha",
                                "No. Detector",
                                "Estado",
                                "Congestión",
                                "Sentido Contrario",
                                "Sentido Circulación",
                                "Longitud",
                                "Distancia",
                                "Intensidad",
                                "Ocupación",
                                "Velocidad",
                                "Error Relativo",
                                "Estado Conexión",
                                "Acciones"
                            ]}
                            body={hookETDStatus.data.map((item: IETDStatus) => ({
                                ...item,
                                created_at: item.created_at,
                                hora: item.created_at
                            }))}
                            keys={[
                                "id",
                                "etd_id",
                                "created_at",
                                "No_detector",
                                "Estado",
                                "Congestion",
                                "Sent_contrario",
                                "Sent_circulacion",
                                "Longitud",
                                "Distancia",
                                "Intensidad",
                                "Ocupacion",
                                "Velocidad",
                                "Error_relativo",
                                "is_online"
                            ]}
                            moment_dates={[{ index: 8, format: "DD/MM/YYYY" }, { index: 9, format: "HH:mm" }]}
                            actions={[{ icon: faInfoCircle, handleClick: (item: any) => { console.log(item); }, variant: "outline-primary", tooltip: "Ver más", disabled: true }]}
                            loading={hookETDStatus.loading}
                            loadingItems={hookETDStatus.pageSize}
                            page={hookETDStatus.page}
                            badges={[{ index: 21 }]}
                            badges_values={[{ col: "is_online", values: [{ color: "#C70039", value: "false", name: "Offline" }, { color: "#008080", value: "true", name: "Online" }] }]}
                        />
                        <PaginationComp
                            page={hookETDStatus.page}
                            defaultPageSize={hookETDStatus.pageSize}
                            totalItems={hookETDStatus.totalItems}
                            onChange={hookETDStatus.changePage}
                        />
                    </div>
                }, {
                    key: '2',
                    label: 'Gráficos',
                    children: <div>
                        <ETDChart etd_id={Number(encryptedId)} />
                    </div>
                }]}
            />
        </div>
    )
}

export default IndexETD;